import axios from "axios";
import moment from "moment";
import { Formik } from "formik";
import * as Yup from "yup";
import React, { useState, useEffect } from "react";
import { Col, Row, Input, Label, Form, Button } from "reactstrap";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import Header from "../../../components/Header";
import { Config, Routes } from "../../../configurations/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { AlertPopups } from "../../../components/AlertPopups";
import { ViewLeaveApplication_API } from "./ViewLeaveApplication_API";

function ViewLeaveApplicationDetail() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const [attachedFileName, setAttachedFileName] = useState("");
	const [reviewLeaveDetailData, setReviewLeaveDetailData] = useState({});
	const initialValues = {
		systemAdminComment: "",
	};
	const [formFields, setFormFields] = useState(initialValues);
	const validate = Yup.object().shape({
		systemAdminComment: Yup.string()
			.required("Comments is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});

	useEffect(() => {
		const tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(`${ViewLeaveApplication_API.GetLeavesForSuperAdmin}/${id}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					setReviewLeaveDetailData(data);
					setAttachedFileName(data.attachmentFile);
					setFormFields({
						systemAdminComment: data.sysAdminComments,
					});
				}
			});
	}, []);

	const getImageByStatus = (status) => {
		//get image
		switch (status.toLowerCase()) {
			case "approved":
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case "rejected":
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.png"
					/>
				);
			case "invalid":
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.png"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.png"
					/>
				);
		}
	};
	const handleSubmit = () => {
		//calling api on submission
		axios
			.put(
				`${ViewLeaveApplication_API.PutSuperAdminComments}/${id}`,
				formFields,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Application Reviewed",
					});
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
		history.push(Routes.AdminViewLeaves);
	};

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="View Leave Application Detail"
								headerBorder="true"
								navigateBack={() =>
									history.push(Routes.AdminViewLeaves)
								}
							/>
							<div className="formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>
										View Leave Application
									</Label>
								</div>

								<Col>
									<Row className="py-2 px-2">
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee Name</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeName
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Application ID</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveApplicationId
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Type</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveType
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Applied Date</div>
											</div>
										</Col>
										<Col md={3} lg={3}>
											<p className="formValueContainer">
												{moment(
													reviewLeaveDetailData.appliedDate
												).format("dd/MM/yyyy ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Start Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{moment(
													reviewLeaveDetailData.startDate
												).format("dd/MM/yyyy ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>End Date</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{moment(
													reviewLeaveDetailData.endDate
												).format("dd/MM/yyyy ")}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Duration</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveDuration
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Attachment</div>
											</div>
										</Col>
										<Col
											md={12}
											lg={3}
											id="attachment-align"
										>
											{attachedFileName ? (
												<p className="formValueContainer">
													<FontAwesomeIcon
														icon={faPaperclip}
														size="1x"
														color="black"
														className="formValueContainer"
													/>
													<a
														href={`${Config.server_url}/${attachedFileName}`}
														target="_blank"
														rel="noopener noreferrer"
														id="attLink"
														class="formValueContainer"
													>
														{attachedFileName}
													</a>
												</p>
											) : (
												<p className="formValueContainer">
													None
												</p>
											)}
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Leave Reason</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.leaveReason
												}
											</p>
										</Col>
										<Col md={12} lg={3}>
											<div className="formDetailHeader">
												<div>Employee's Comments</div>
											</div>
										</Col>
										<Col md={12} lg={3}>
											<p className="formValueContainer">
												{
													reviewLeaveDetailData.employeeComments
												}
											</p>
										</Col>
									</Row>
								</Col>
							</div>

							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Emergency Contact</Label>
								</div>

								<Row className="py-2 px-4">
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Person Name</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactName
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Phone 1</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactPhone1
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Phone 2</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactPhone2
											}
										</p>
									</Col>
									<Col md={12} lg={3}>
										<div className="formDetailHeader">
											<div>Address</div>
										</div>
									</Col>
									<Col md={12} lg={3}>
										<p className="formValueContainer">
											{
												reviewLeaveDetailData.employeeEmergencyContactAddress
											}
										</p>
									</Col>
								</Row>
							</div>
							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Application Status</Label>
								</div>
								<Row className="py-2 px-3">
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Approvers
											</div>
										</Row>
										<p className="px-2 formValueContainer">
											{
												reviewLeaveDetailData.supervisorName
											}
										</p>
										<p className="px-2 my-2 formValueContainer">
											{reviewLeaveDetailData.adminName}
										</p>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Application Status
											</div>
										</Row>
										<div className="px-5 formDetailHeader">
											<p className="formValueContainer">
												{reviewLeaveDetailData.supervisorStatus
													? getImageByStatus(
															reviewLeaveDetailData.supervisorStatus
													  )
													: null}
											</p>
										</div>
										<div className="px-5 my-2 formDetailHeader">
											<p className="formValueContainer">
												{reviewLeaveDetailData.adminStatus
													? getImageByStatus(
															reviewLeaveDetailData.adminStatus
													  )
													: null}
											</p>
										</div>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Comments
											</div>
										</Row>
										<div className="px-2 mr-5">
											<Input
												type="textarea"
												name="supComments"
												disabled={true}
												className="supDesciptionBox"
												value={
													reviewLeaveDetailData.supervisorComments
												}
											/>
										</div>
										<div className="px-2 mr-5">
											<Input
												type="textarea"
												disabled={true}
												name="adminMgrComments"
												className="my-2 supDesciptionBox"
												value={
													reviewLeaveDetailData.adminManagerComments
												}
											/>
										</div>
									</Col>
									<Col lg={3}>
										<Row>
											<div className="px-4 formDetailHeader">
												Last Updated Date
											</div>
										</Row>
										<p className="px-2 formValueContainer">
											{reviewLeaveDetailData.supervisorLastUpdatedDate
												? moment(
														reviewLeaveDetailData.supervisorLastUpdatedDate
												  ).format("dd/MM/yyyy HH:mm")
												: null}
										</p>
										<p className="px-2 my-3 formValueContainer">
											{reviewLeaveDetailData.adminLastUpdatedDate
												? moment(
														reviewLeaveDetailData.adminLastUpdatedDate
												  ).format("dd/MM/yyyy HH:mm")
												: null}
										</p>
									</Col>
								</Row>
							</div>
							<div className=" my-4 formInfoContainer">
								<div className="formInfoContainerHeader">
									<Label sm={12}>
										Administrator's Review{" "}
									</Label>
								</div>
								<Formik
									enableReinitialize={true}
									initialValues={formFields}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<Form>
											<Row className="py-2">
												<Col md={12} lg={4}>
													<div className="px-4 formDetailHeader">
														<div>
															System Administrator
															Comments{" "}
															<span className="required">
																*
															</span>
														</div>
													</div>
												</Col>

												<Col lg={4}>
													<div className="px-4 formDetailHeader">
														<Input
															type="textarea"
															name="supervisorComments"
															className={`supDesciptionBox ${
																errors.systemAdminComment
																	? "h-auto invalid"
																	: "h-auto"
															}`}
															onChange={(
																event
															) => {
																setFormFields({
																	systemAdminComment:
																		event
																			.target
																			.value,
																});
															}}
															disabled={
																reviewLeaveDetailData.sysAdminComments !=
																null
															}
															value={
																formFields.systemAdminComment
															}
															maxLength="400"
														/>
													</div>
												</Col>
											</Row>

											<div className="btns">
												<Button
													className="approve-btn"
													onClick={handleSubmit}
												>
													Save
												</Button>
											</div>
										</Form>
									)}
								</Formik>
							</div>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
}

export default ViewLeaveApplicationDetail;
